import * as React from "react";
import classNames from "classnames";
import "./Title.scss";

type Props = {
  children: React.ReactNode;
  size: "h1" | "h2" | "h3";
}

type Ref = HTMLTitleElement;

const Title = React.forwardRef<Ref, Props>(({
  children,
  size,
}, ref) => {
  const className = classNames("nimbus-web--title", `nimbus-web--title--${size}`);
  return React.createElement(
    size,
    { className: className, ref: ref },
    children,
  );
});

export default Title;
